import devPostData from '../../../dev/dev-post-data.js'

export const getDevPostData = () => devPostData
